/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/no-identical-functions */
import { client, clientCall, client1, getJWToken } from "./client";
import jwtDecode from "jwt-decode";
import { appConfig } from "../config/app-config";
import { CancelToken } from "axios";
import { ProductPermissions } from "../constants/constants";
import { CustSurveyType } from "../types/types";
import { FieldSheetResponse, GetCustomerFieldSheetsPayload, StoreConfigsPayload, StoreConfigsResponse, StoreDetailResponse, User } from "../types/types";
import { ApiCallParams } from "../components/ReactComponents/Interface";
import { LocalSourcingApiResponse, LocalSourcingResponseBody, UploadLocalSourcingReceiptPayload } from "../types/localSourcing";
import { StoreActionPageRequest } from '../components/ReactComponents/StoreAction/storeActionDomain';
import { StoreActionTransportResponse, StoreActionWireStatus } from '../components/ReactComponents/StoreAction/storeActionDomain';

const agreementBaseUrl = appConfig.apiUrls.agreement;
const TwoFactorBaseURL = appConfig.apiUrls.storemgmt;
const getCurrentUserBaseURL = appConfig.apiUrls.menu;
const customerBaseUrl = appConfig.apiUrls.customer;
const inventoryBaseUrl = appConfig.apiUrls.inventory;

export const getSalesLead = async (paramOnlineTransactionsalesLead: any) => {
  try {
    return await clientCall(
      `leads`,
      { method: "POST", body: paramOnlineTransactionsalesLead },
      appConfig.apiUrls.micro
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};
export const GetAgreementCustomer = async (Pathparams: any) => {
  return await clientCall(
    `agreement/customers/${Pathparams}?source=ENT`,
    { method: "GET" },
    agreementBaseUrl
  );
};

export const getReference = async (referenceKey: any[],
  cacheKey: string) : Promise<any[]> => {
  return await clientCall(
    `references`,
    { method: "POST", body: { references: referenceKey, cacheKey }, },
    appConfig.apiUrls.am
  );
};



export const logActivity = async (payload: any) => {
  return await clientCall(
    '/customer/logactivity',
    { method: "POST", body: { ...payload } },
    appConfig.apiUrls.am
  );
};
type LegacyStoreActionsItemRequest = {
  readonly storeNum: string;
  readonly limit: number;
  readonly offset: number;
  readonly status?: StoreActionWireStatus;
};

// Existing callers use storeNum; the redesign uses the status-aware page request.
type StoreActionsItemRequest =
  | StoreActionPageRequest
  | LegacyStoreActionsItemRequest;

interface StoreActionsItemRequestConfig {
  readonly signal?: AbortSignal;
}

export const getStoreActionsItem = async (
  payload: StoreActionsItemRequest,
  requestConfig?: StoreActionsItemRequestConfig
): Promise<StoreActionTransportResponse> => {
  const storeNumber =
    'storeNumber' in payload ? payload.storeNumber : payload.storeNum;
  const status = payload.status ? `&status=${payload.status}` : '';

  return clientCall(
    `storeactionsitem/details/${storeNumber}?limit=${payload.limit}&offset=${payload.offset}${status}`,
    { method: "GET", ...requestConfig },
    appConfig.apiUrls.micro
  );
};
export interface ManageStoreActionItemsRequest {
  readonly storeNumber: string;
  readonly storeActionItemIds: ReadonlyArray<string>;
  readonly reopen?: true;
}

export interface ManageStoreActionItemsResponse {
  readonly status: number;
  readonly data?: {
    readonly storeActionItemIds?: ReadonlyArray<string>;
  };
}

export const manageStoreActionItems = async (
  payload: ManageStoreActionItemsRequest
): Promise<ManageStoreActionItemsResponse> =>
  clientCall(
    `/storeactionitems/manage`,
    { method: "POST", body: payload },
    appConfig.apiUrls.micro
  );
type PrintEditPricetagRequestConfig = {
  readonly signal?: AbortSignal;
};

export const getPrintEditPricetagGrid = async (
  storeNumber: string,
  requestConfig?: PrintEditPricetagRequestConfig
): Promise<unknown> => {
  return clientCall(
    `inventory/pricetag/list/${storeNumber}?limit=20&offset=1`,
    { method: "GET", ...requestConfig },
    inventoryBaseUrl
  );
};

export const getOnlinetransaction = async (storeNumber: any) => {
  /* eslint-disable no-console */
  console.log("fe-lambda hit");
  try {
    return await clientCall(
      `online-transaction/${storeNumber}`,
      { method: "GET" },
      appConfig.apiUrls.micro
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};
export const getSalesLeadInvenventoryLambda = async (
  paramsSalesInventory: any
) => {
  return await clientCall(
    `lead/inventory-status`,
    { method: "POST", body: paramsSalesInventory },
    appConfig.apiUrls.micro
  );
};

export const logWorkedHistory = async (
  payload: CustSurveyType
) => {
  return await clientCall(
    `customer/logactivity`,
    { method: "POST", body: payload },
    appConfig.apiUrls.am
  );
};


export const getCustomerForsalesLead = async (gcid: any) => {
  return await clientCall(
    `customer/${gcid}/detail`,
    { method: "GET" },
    customerBaseUrl
  );
};

export const UpdateCustomerForsalesLead = async (
  paramsUpdateSalesLead: any,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  customerId: any
) => {
  return await clientCall(
    `customer/post-no-decision`,
    { method: "POST", body: paramsUpdateSalesLead },
    customerBaseUrl
  );
};

export const getCurrentUser = async (): Promise<User> =>
  await client("users/current", { method: "GET" }, appConfig.apiUrls.container, true);

export const getUserPreferences = async (productType: string) =>
  await client(
    `users/current/preferences/${productType}`,
    { method: "GET" },
    appConfig.apiUrls.container
  );

export const getUserPermissions = async (
  productType: string
): Promise<ProductPermissions[]> =>
  await client(
    `users/current/permissions/${productType}`,
    { method: "GET" },
    appConfig.apiUrls.container
  );

export const setUserPreferences = async (
  productType: string,
  payload: Record<string, any>,
  cancelToken?: CancelToken
) =>
  await client(
    `users/current/preferences/${productType}`,
    {
      method: "PATCH",
      body: [payload],
      cancelToken,
    },

    appConfig.apiUrls.container
  );

export const getUserStores = async () =>
  await client(
    "users/current/stores?q=permissions[:includes]=RACPAD_DAP",
    { method: "GET" },
    appConfig.apiUrls.container
  );

export const GenerateAgreementDoc = async (Payload: any) => {
  return await clientCall(
    `agreement/document/generate`,
    { method: "POST", body: Payload },
    agreementBaseUrl
  );
};
export const managePoAcimaFn = async (bodyobj: any) => {
  return await clientCall(
    `manage/${bodyobj.purchaseOrderNumber}`,
    { method: 'POST', body: bodyobj },
    appConfig.apiUrls.acimapo
  );
};
export const GetCustomerinfo = async (agreementId: any) => {
  return await clientCall(
    `agreement/customers/${agreementId}`,
    { method: "GET" },
    agreementBaseUrl
  );
};

//Authentication popup
export const getprofileaccess = async (Payload: any) => {
  return await clientCall(
    `store-access`,
    { method: "POST", body: Payload },
    TwoFactorBaseURL
  );
};
export const getPinDetails = async (Payload: any) => {
  return await clientCall(
    `coworker`,
    { method: "POST", body: Payload },
    TwoFactorBaseURL
  );
};

export const getsecondfactor = async (Payload: any) => {
  return await clientCall(
    `coworker-authentication`,
    { method: "POST", body: Payload },
    TwoFactorBaseURL
  );
};
export const getConfigDetails = async (payload: any) => {
  try {
    return await clientCall(
      `store-details`,
      { method: "POST", body: payload },
      TwoFactorBaseURL
    );
  } catch (e: any) {
    return null;
  }
};

export const GetEmployeeID = async () => {
  return await clientCall(
    `user/current`,
    { method: "GET" },
    getCurrentUserBaseURL
  );
};

export const GetRole = async (payload: any) => {
  return await clientCall(
    `menu-and-stores`,
    { method: "POST", body: payload },
    getCurrentUserBaseURL
  );
};
export interface StoreActionCoworkerRoleResponse {
  readonly status: number;
  readonly data: {
    readonly coworkerProfile: {
      readonly role: string;
    };
  };
}

export const getMenuAndStores = async (
  coworkerId: string
): Promise<unknown> => GetRole({ coworkerId });

type StoreActionJwtClaims = {
  readonly coworkerId?: string;
  readonly sub?: string;
};

export const getStoreActionCoworkerId = async (): Promise<string> => {
  const claims = jwtDecode<StoreActionJwtClaims>(await getJWToken());
  const coworkerId = claims.coworkerId || claims.sub;

  if (!coworkerId) {
    throw new Error('Missing coworker identity');
  }

  return coworkerId;
};
// export const getPrintEditPricetagGrid = async (storeNumber: any) => {
//   return await clientCall(
//     `inventory/pricetag/list/${storeNumber}`,
//     { method: 'GET' },
//     inventoryBaseUrl
//   );
// };
export const getPrintDocument = async (payload: any) => {
  return await clientCall(
    `agreement/document/print`,
    { method: "POST", body: payload },
    agreementBaseUrl
  );
};

export const getTextMessage = async () => {
  return await clientCall(
    `dashboard/textmsg`,
    { method: "GET" },
    appConfig.apiUrls.micro
  );
};

export const getCustomerStatesList = (country = 'state_province') =>
    clientCall(`references/entity?referenceCode=${country}`, 
    { method: "GET" },
    appConfig.apiUrls.am
  );

export const GetCustomer = async (customerId: any, payload: any) => {
  return await clientCall(
    `customer/${customerId}`,
    { method: "PUT", body: payload },
    customerBaseUrl
  );
};

export const GetCustomerDetail = async (gcid: any) => {
  return await clientCall(
    `customer/${gcid}/detail`,
    { method: "GET" },
    customerBaseUrl
  );
};

export const getStatsInfo = async (date: string, isRacdbStoreStats: string) => {
  return await clientCall(
    `dashboard/store/stats?date=${date}&isRacdbStoreStats=${isRacdbStoreStats}`,
    { method: "GET" },
    appConfig.apiUrls.micro
  );
};

export const GetStatsStatus = async (payload: any) => {
  return await clientCall(
    `store-details`,
    { method: "POST", body: payload },
    appConfig.apiUrls.storemgmt
  );
};
export const getDrawerDetail = async (payload: any) => {
  /* eslint-disable no-console */
  /* eslint-enable no-console */
  /* eslint-enable no-console */
  try {
    return await clientCall(
      `manage/reconcil`,
      { method: "POST", body: payload },
      appConfig.apiUrls.cashmgmt
    );
  } catch (e: any) {
    return null;
  }
};
export const GetRemoteLoginStatus = async (Payload: any) => {
  return await clientCall(
    `cashmgmt/duo/auth`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.cashmgmt
  );
};

export const updateTransferReceiveDetails = async (req: any) => {
  return await clientCall(
    'inventory/transfer/update',
    { method: 'POST', body: req },
    appConfig.apiUrls.inventory
  );
}


export const GetFscInfoDetail = async (payload: any) => {
  try {
    return await clientCall(
      `fsc/info?storeNumber=${payload.storeNumber}&type=${payload.type}`,
      { method: "POST" },
      appConfig.apiUrls.micro
    );
  } catch (e: any) {
    return null;
  }
};
export const GetFscContest = async (payload: any) => {
  try {
    // eslint-disable-next-line no-debugger
    let url = `fsc/info?storeNumber=${payload.storeNumber}&type=${payload.type}`;
    if (payload.operationCommunicationId) {
      url =
        url + `&operationCommunicationId=${payload.operationCommunicationId}`;
    }
    return await clientCall(
      url,
      { method: "POST" },
      appConfig.apiUrls.micro
    );
  } catch (e: any) {
    return null;
  }
};

export const GetReferenceValues = async (param: string) => {
  try {
    return await clientCall(
      `reference?referenceName=${param}`,
      { method: "GET" },
      appConfig.apiUrls.cashmgmt
    );
  } catch (e: any) {
    return null;
  }
};
export const getDapEvent = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `event/search`,
      { method: "POST", body: payload },
      appConfig.apiUrls.storemgmt
    );
  } catch (err: any) {
    return err;
  }
};
export interface StoreActionDapAppointmentRequest {
  readonly storeNumber: string;
  readonly appointmentTypes: ReadonlyArray<'D' | 'CO' | 'CI'>;
  readonly startDate: string;
  readonly endDate: string;
  readonly appointmentId: string;
}

export interface StoreActionDapAppointmentResponse {
  readonly status: number;
  readonly data: unknown;
}

export const getStoreActionDapAppointment = async (
  request: StoreActionDapAppointmentRequest
): Promise<unknown> => getDapEvent(request);
export const EventHistory = async (Payload: any) => {
  return await clientCall(
    "event/history",
    { method: "POST", body: Payload },
    appConfig.apiUrls.storemgmt
  );
};
export const updateEventStatus = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `appointment/action`,
      { method: "POST", body: payload },
      appConfig.apiUrls.storemgmt
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};

export const getTimeSlot = async (Payload: any) => {
  return await clientCall(
    "agreement/timeslots",
    { method: "POST", body: Payload },
    appConfig.apiUrls.agreement
  );
};
export const getAgreementDelivery = async (
  agreementId: any,
  appointmentId?: any
) => {
  return await clientCall(
    `agreement/delivery/info/${agreementId}?appointmentId=${appointmentId}`,
    { method: "Get" },
    appConfig.apiUrls.agreement
  );
};
export const getnextpaymentamount = async (Payload: any) => {
  return await clientCall(
    `agreement/getnextpaymentamount`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.agreement
  );
};
export const getAgreementInfo = async (AgreementId: any) => {
  return await clientCall(
    `agreement/${AgreementId}`,
    { method: "GET" },
    appConfig.apiUrls.agreement
  );
};
export const LoadDeliveryreceipt = async (agreementId: string) => {
  return await clientCall(
    `agreement/delivery/receipt/${agreementId}`,
    { method: "GET" },
    appConfig.apiUrls.agreement
  );
};
export const GetCustomerId = async (GCID: string) => {
  try {
    return await clientCall(
      `customer/${GCID}/detail`,
      { method: "GET" },
      customerBaseUrl
    );
  } catch (err: any) {
    /* eslint-disable no-console */
    console.log(err);
    /* eslint-enable no-console */
    return "Error";
  }
};
export const GenerateReceipt = async (bodyobj: any) => {
  return await clientCall(
    `agreement/generatereceipt`,
    { method: "POST", body: bodyobj },
    appConfig.apiUrls.agreement
  );
};
export const GenerateSwitchoutReceipt = async (bodyobj: any) => {
  return await clientCall(
    `agreement/generatereceipt`,
    { method: "POST", body: bodyobj },
    appConfig.apiUrls.agreement
  );
};
export const Confirmdelivery = async (updatedeliverystatus: any) => {
  return await clientCall(
    `agreement/delivery/status/update`,
    { method: "PUT", body: updatedeliverystatus },
    appConfig.apiUrls.agreement
  );
};
export const Recieptsign = async (updatesign: any) => {
  return await clientCall(
    `agreement/delivery/receipt/sign`,
    { method: "PUT", body: updatesign },
    appConfig.apiUrls.agreement
  );
};
export const LoadswitchoutDeliveryreceipt = async (agreementId: string) => {
  return await clientCall(
    `agreement/delivery/receipt/${agreementId}?isSwitchOut=1`,
    { method: "GET" },
    appConfig.apiUrls.agreement
  );
};
export const FinishdeliveryStatus = async (complete: any) => {
  return await clientCall(
    `agreement/delivery`,
    { method: 'POST', body: complete },
    appConfig.apiUrls.agreement
  );
};
export const CheckSign = async (agreementId: string) => {
  return await client1(
    `agreement/delivery-receipt/sign/check/${agreementId}`,
    { method: 'GET' },
    appConfig.apiUrls.agreement
  );
};
export const manageAppointment = async (Payload: any) => {
  return await clientCall(
    "event/manage",
    { method: "POST", body: Payload },
    appConfig.apiUrls.storemgmt
  );
};
export const getSalesPersonOptions = async (
  StoreNumber: any
) => {
  const customerId = "12345"
  return await clientCall(
    `agreement/options/${customerId}?storeNumber=${StoreNumber}&isSwitchOut=1`,
    { method: 'GET' },
    appConfig.apiUrls.agreement
  );
};
export const getStoreTask = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `task/${payload}`,
      { method: 'GET' },
      appConfig.apiUrls.storemgmt
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};
export const getStoreTaskHistory = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `task/history/${payload}`,
      { method: 'GET' },
      appConfig.apiUrls.storemgmt
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};
export const searchStoreTask = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `task/search`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.storemgmt
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};

export const ActiveMailing = async (payload: any) => {
  // eslint-disable-next-line no-console
  console.log('Inside the usee.tsx')
  return await clientCall(
    `customer/address/update`,
    { method: 'POST', body: payload },
    appConfig.apiUrls.customers
  );
}

export const createStoreTask = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `task/create`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.storemgmt
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};
export const getmenuandstore = async (falg?: any) => {
  try {
    const jwtToken = await getJWToken() || ''
    const decodedToken: any = jwtDecode(jwtToken);
    // eslint-disable-next-line no-console
    console.log("decodedToken", decodedToken);
    const parameters: any = {
      coworkerId: decodedToken["custom:employeeId"],
    };
    if (falg == 'MENU') {
      parameters.storesRequired = false
      parameters.menuRequired = true
      parameters.menuRequest = {
        association: {
          associationCode: sessionStorage.getItem('storeNumber'),
          associationType: "STORE",
        },
      };
    }
    return await clientCall(
      "menu-and-stores",
      { method: "POST", body: parameters },
      getCurrentUserBaseURL
    );
  } catch (e: any) {
    return null;
  }
};
export const storeException = async (payload: any) => {
  /* eslint-disable no-console */
  try {
    return await clientCall(
      `agreement/store/exception`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.agreement
    );
  } catch (err: any) {
    return err;
    //throw err;
  }
};

export const featureFlags = async (bodyobject: any) => {
  return await clientCall(
    `agreement/address/eventId`,
    { method: 'POST', body: bodyobject },
    appConfig.apiUrls.agreement
  );
};

export const generateFieldVisitAnswer = async (payload: any) => {
  const TempAccessToken = "QAToken";
  return await clientCall(
    `update`,
    { method: "POST", body: payload },
    appConfig.apiUrls.storemgmt,
    TempAccessToken,
    true
  );
};

export const getLocalSourcingTransactions = async (
  storeNumber: string,
  pageNumber = 1,
  pageSize = 20
): Promise<LocalSourcingApiResponse> => {
  try {
    const response = await clientCall(
      `localsourcing/summary`,
      {
        method: "POST",
        body: {
          storeNumbers: [storeNumber],
          pageNumber,
          pageSize,
        },
      },
      agreementBaseUrl
    ) as { status: number; data: LocalSourcingResponseBody | null };

    return {
      status: response?.status ?? 0,
      data: (response?.data ?? null) as LocalSourcingResponseBody | null,
    };
  } catch (err: unknown) {
    const e = err as { response?: { status?: number; data?: { errors?: Array<{ message?: string }> } }; message?: string };
    // eslint-disable-next-line no-console
    console.warn('[localSourcing] summary request failed', {
      status: e?.response?.status,
      message: e?.response?.data?.errors?.[0]?.message || e?.message,
    });
    return { status: 0, data: null };
  }
};

export const uploadLocalSourcingReceipt = async (
  payload: UploadLocalSourcingReceiptPayload
): Promise<{ status: number; data: { id?: string } | null }> => {
  try {
    const response = await clientCall(
      `localsourcing/summary`,
      { method: 'POST', body: { flow: 'UPLOAD_RECEIPT', ...payload } },
      agreementBaseUrl
    ) as { status: number; data: { id?: string } | null };

    return {
      status: response?.status ?? 0,
      data: (response?.data ?? null) as { id?: string } | null,
    };
  } catch (err: unknown) {
    const e = err as { response?: { status?: number; data?: { errors?: Array<{ message?: string }> } }; message?: string };
    // eslint-disable-next-line no-console
    console.warn('[localSourcing] receipt upload failed', {
      status: e?.response?.status,
      message: e?.response?.data?.errors?.[0]?.message || e?.message,
    });
    return { status: e?.response?.status ?? 0, data: null };
  }
};

export const getRetentionOffers = async (Payload: any) : Promise<any>  => {
  // horrible name 
  return await getFreeTimeBalance( Payload );  
};

export const getFreeTimeBalance = async (Payload: any) => {
  return await clientCall(
    `retention/offers`,
    { method: 'POST', body: Payload },
    customerBaseUrl
  );
};
export const saveSurveyForm = async (Payload: any) => {
  return await clientCall(
    `store/survey/agreement`,
    { method: "POST", body: Payload },
    TwoFactorBaseURL
  );
};

export const getSavedSurvey = async (agreementId: any) => {
  return await clientCall(
    `store/survey/getagreement/${agreementId}`,
    { method: "GET" },
    TwoFactorBaseURL
  );
};

export interface InventoryInformationResponse {
  readonly status?: number;
  readonly data?: unknown;
}

export const GetInventoryInformation = async (
  inventoryId: string | number
): Promise<InventoryInformationResponse> => {
  return await clientCall(
    `inventory/1?storeNum=&inventoryId=${inventoryId}`,
    { method: 'GET' },
    inventoryBaseUrl
  );
};

export const RefundLeadAmount = async (payload: any) => {
  try {
    return await client(
      `saleLead/refund`,
      { method: 'POST', body: payload },
      customerBaseUrl,
      true
    );
  } catch (e: any) {
    return null;
  }
};

export const fetchOrganizationDetails = async (Payload: any) => {
  return await clientCall(
    `hierarchy`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.pricing
  );
};

export const getSalesPersonOptions1 = async (Payload: any) => {
  return await clientCall(
    `event/search`,
    { method: "POST", body: Payload },
    appConfig.apiUrls.storemgmt
  );
};

export const getFieldSheets = async (
  payload: GetCustomerFieldSheetsPayload
): Promise<FieldSheetResponse> =>{
  return await clientCall(
    `customers/field-sheets`,
    { method: "POST", body: {...payload } },
    appConfig.apiUrls.am
  );
}

export const getStoreConfigs = async (
  payload: StoreConfigsPayload,
  cancelToken?: CancelToken
): Promise<StoreConfigsResponse[]> => {
  return await clientCall(`/config/get-store-profile`,
    {method: 'POST', body: { ...payload }, cancelToken },
    appConfig.apiUrls.am
  );
};

export const getStoreDetailByNumber = (
  storeNumber: string,
  cancelToken?: CancelToken
): Promise<StoreDetailResponse> => {
  return client(`stores/${storeNumber}/details`, {
    method: 'GET',
    cancelToken,
  },appConfig.apiUrls.container);
};

export const getVerificationDocuments = async (payload: any) => {
  try {
    return await client(
      `agreement/document/print`,
      { method: 'POST', body: payload },
      appConfig.apiUrls.agreement,
      true
    );
  } catch (e: any) {
    return null;
  }
};


export const SendDOFLink = async (Payload: any) => {
  return await clientCall(
    `intellicheck/sendlink`,
    { method: "POST", body: Payload },
    customerBaseUrl
  );
};

export const GetCustomerStgData = async (stgCustomerProfileId: string) => {
  return await clientCall(
    `fetch/${stgCustomerProfileId}`,
    { method: 'Get' },
    customerBaseUrl
  );
};

// Updates the staging identity record via the /manage endpoint after the Call Center
// authorizes a manual selfie: sets selfieVerificationStatus APPROVED and livenessChecked 1.
// All existing identity fields are echoed back to avoid NOT NULL violations.
export const ManageCustomerStgData = async (
  stgCustomerProfileId: string,
  stgCustomerIdentityId: string,
  existingIdentityData: any,
  updates: {
    agreementId?: string;
    livenessChecked?: number;
    selfieVerificationStatus?: string;
  } = {}
) => {
  return await clientCall(
    `manage`,
    {
      method: 'POST',
      body: {
        action: 'UPD',
        stgCustomerProfileId,
        identityInfo: {
          stgCustomerIdentityId,
          curpId: existingIdentityData?.curpId || undefined,
          voterId: existingIdentityData?.voterId || undefined,
          rfcId: existingIdentityData?.rfcId || undefined,
          transactionGuid: existingIdentityData?.transactionGuid || null,
          transactionDate: existingIdentityData?.transactionDate || null,
          livenessChecked: updates.livenessChecked ?? 1,
          identityVerificationStatus: existingIdentityData?.identityVerification || undefined,
          idValidationType: existingIdentityData?.idValidationType || undefined,
          selfieValidationType: existingIdentityData?.selfieValidationtType || undefined,
          selfieVerificationStatus: updates.selfieVerificationStatus ?? existingIdentityData?.selfieVerificationStatus ?? undefined,
          agreementId: updates.agreementId || existingIdentityData?.agreementId || undefined
        }
      }
    },
    customerBaseUrl
  );
};


export const makeApiClientCall = async ({ url, method, payload, baseUrl }: ApiCallParams) => {
  try {
    const options: { method: string; body?: any } = { method };
    if (payload) {
      options.body = payload;
    }
    return await clientCall(url, options, baseUrl);
  } catch (e: any) {
    return null;
  }
};
